import {Inject, Injectable} from "@angular/core";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoader {
    private static promise;

    constructor(@Inject(DOCUMENT) protected document: Document) {
    }

    public load() {
        // First time 'load' is called?
        if (!GoogleMapsLoader.promise) {

            // Make promise to load
            GoogleMapsLoader.promise = new Promise( resolve => {

                // Set callback for when google maps is loaded.
                this.document.defaultView['__onGoogleLoaded'] = (ev) => {
                    resolve('google maps api loaded');
                };

                let node = document.createElement('script');
                node.type = 'text/javascript';
                node.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAu609sTknuHYA0CtLFOHmU3IJDJPzmBMY&libraries=places&callback=__onGoogleLoaded";
                document.getElementsByTagName('head')[0].appendChild(node);
            });
        }

        // Always return promise. When 'load' is called many times, the promise is already resolved.
        return GoogleMapsLoader.promise;
    }
}
